import { IsBoolean, IsEnum, IsOptional, IsUUID } from "class-validator";
import { NotificationTypesEnum } from "../../enums";

export class UserNotificationSettingDto {
	id: string;
	userId: string;
	notificationTypeId: NotificationTypesEnum;
	enabled: boolean;
	createdAt: Date;
	updatedAt: Date;
}

export class UpdateUserNotificationSettingDto {
	@IsOptional()
	@IsUUID()
	id?: string;

	@IsUUID()
	@IsEnum(NotificationTypesEnum)
	notificationTypeId: NotificationTypesEnum;

	@IsBoolean()
	enabled: boolean;
}
